import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import "./new-dora-inputs.scss";
import "./DoraCheckbox.scss";
const DoraCheckbox = (props) => {
    const { id, register, style, checked, onChange, disabled, className } = props;
    const wrapperClasses = classnames("dora-checkbox__wrapper", className);
    const classes = classnames("dora-checkbox", {
        "dora-checkbox--checked": checked,
        "dora-checkbox--disabled": disabled,
    });
    const onChangeProp = !register
        ? {
            onChange: (e) => onChange && onChange(e.target.value),
        }
        : {};
    const checkedProp = !register ? { checked } : {};
    return (_jsxs("div", { className: wrapperClasses, style: style, children: [_jsx("input", { ...(id && { id }), ...register, ...checkedProp, ...onChangeProp, disabled: disabled, type: "checkbox", className: classes }), _jsx("div", { className: "dora-checkbox__svg-wrapper", children: _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", viewBox: "0 0 12 12", fill: "none", children: _jsx("path", { d: "M10 3L4.5 8.5L2 6", stroke: "#3E68A3", strokeWidth: "1.6666", strokeLinecap: "round", strokeLinejoin: "round" }) }) })] }));
};
const UFDoraCheckbox = (props) => {
    return _jsx(DoraCheckbox, { ...props });
};
export { DoraCheckbox, UFDoraCheckbox };
//# sourceMappingURL=DoraCheckbox.js.map